import './ColunaBancoDestino.css';

export default function ColunaBancoDestino({ title, subtitle, values = [], onTap, selecionado, groupId }) {

  const handleSelect = (item) => {
    if (selecionado && selecionado.idEndereco === item.idEndereco) {
      onTap(null);
    } else {
      onTap(item);
    }
  };

  const renderItem = (item) => (
    <label className="item-plano" key={item.idEndereco}>
      <input
        type="radio"
        name={`plano-${groupId}`}
        checked={selecionado && selecionado.idEndereco === item.idEndereco}
        onChange={() => handleSelect(item)}
      />
      <div className="texto">
        <h3 className="title">{item.titulo}</h3>
        <h5 className="subtitle">{item.subtitulo}</h5>
      </div>
    </label>
  );

  return (
    <div className="coluna-bd">
      <h1 className='title-bd'>
        {title}
      </h1>

      {subtitle && (
        <h1 className='subtitle-bd'>
          {subtitle}
        </h1>
      )}

      <hr className='divider' />

      {values.map(renderItem)}
    </div>
  );
}